export default __webpack_public_path__ + "static/media/fourth.5faab4fb.jpeg";